module.exports = __webpack_public_path__ + "img/Youssef.5a4518bb.jpg";